// extracted by mini-css-extract-plugin
export default {"formPadrao":"FormPadrao_formPadrao__jJtEP"};